var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserInactiveIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Navbar=Disable"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Profile"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    d: "M9.28877 12.2694C6.05402 12.2694 3.29102 12.7794 3.29102 14.8194C3.29102 16.8602 6.03677 17.3882 9.28877 17.3882C12.5235 17.3882 15.2865 16.8789 15.2865 14.8382C15.2865 12.7974 12.5415 12.2694 9.28877 12.2694Z",
    fill: "url(#paint0_linear_493_714)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 4",
    opacity: 0.4,
    d: "M9.28882 10.3262C11.4923 10.3262 13.2578 8.55993 13.2578 6.35718C13.2578 4.15443 11.4923 2.38818 9.28882 2.38818C7.08607 2.38818 5.31982 4.15443 5.31982 6.35718C5.31982 8.55993 7.08607 10.3262 9.28882 10.3262Z",
    fill: "url(#paint1_linear_493_714)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_493_714",
    x1: 2.42178,
    y1: 10.956,
    x2: 4.60345,
    y2: 20.5851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8A8A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_493_714",
    x1: 4.74461,
    y1: 0.35146,
    x2: 11.247,
    y2: 12.598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8A8A8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserInactiveIcon);
export default __webpack_public_path__ + "static/media/UserInactiveIcon.37ecf1ead477e5125cb154de9c35a680.svg";
export { ForwardRef as ReactComponent };